
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 1.692a8.333 8.333 0 110 16.667 8.333 8.333 0 110-16.667zm3.83 4.503a.496.496 0 00-.636-.055C10.786 7.83 9.427 8.83 9.116 9.14A1.252 1.252 0 0010 11.275c.332 0 .65-.131.884-.365.183-.184 1.182-1.543 2.998-4.081a.492.492 0 00-.052-.634zm.753 2.997a.833.833 0 100 1.667.833.833 0 000-1.667zm-9.166 0a.833.833 0 100 1.667.833.833 0 000-1.667zm1.931-2.997a.834.834 0 10-1.178 1.18.834.834 0 001.178-1.18zM10 4.61a.833.833 0 100 1.666.833.833 0 000-1.666z","fill":"#fff"}})])
          )
        }
      }
    